import { createStructuredSelector } from 'reselect';

export const isCompleted = ({ progress }) => !!progress.completedDate;

export const isIncomplete = ({ progress }) =>
  progress.startDate && !progress.completedDate;

export const isJourneyStarted = content => !!content.progress.startedAt;

export const getComputedProps = createStructuredSelector({
  isJourneyStarted,
  isCompleted,
  isIncomplete,
});
